// Claude: shared meeting utility — extracted from useSellersListState, useBuyersListState, RFXDetail, RFXResponses 10-04-2026
import { MEETING_REQUEST_STATUS } from "../Constants/data";

export const isNewMeetingAllowed = (status: string): boolean =>
  [
    MEETING_REQUEST_STATUS.CANCELLED,
    MEETING_REQUEST_STATUS.EXPIRED,
    MEETING_REQUEST_STATUS.CLOSED,
    MEETING_REQUEST_STATUS.INCOMPLETE,
  ].includes(status);
